export const NIP_VALIDATION = 'nip_validation';
export const VALIDATION_2FA = 'validation_2fa';
export const CHOOSE_VALIDATION_METHOD = 'choose_validation_method';

export const STORAGE_VALIDATING_SCREEN_METHOD = 'VALIDATING_SCREEN_METHOD';
export const STORAGE_VALIDATING_SCREEN_METHOD_APPLICATION = 'VALIDATING_SCREEN_METHOD_APPLICATION';
export const SMS_METHOD = 'SMS';
export const CALL_METHOD = 'CALL';

export const TOKEN_LENGTH = 6;

export const TOKEN_TYPES = {
  CIRCULO_NIP: 'circulo-nip',
  TOKEN_2FA: '2fa',
};

export const CIRCULO_NIP_EVENT_NAMES = {
  SCREEN: 'validating',
  SEND_AGAIN_SUCCESS: 'kpay_validating_resend_nip',
  STEP_NAME: 'Nip',
  VALIDATOR_ERROR: 'kpay_validating_nip_error',
  VALIDATOR_SUCCESS: 'kpay_validating_success_nip_validation',
};

export const TOKEN_2FA_EVENT_NAMES = {
  SCREEN: 'verification2fa',
  SEND_AGAIN_SUCCESS: 'kpay_verification_resend_token_2fa',
  STEP_NAME: '2FA',
  VALIDATOR_ERROR: 'kpay_verification_error_2fa',
  VALIDATOR_SUCCESS: 'kpay_verification_success_2fa',
};
